import type { ReportColumn, ReportRow } from "./types";

/** Beregner en summeringsrad fra radene etter kolonnenes summary-regler.
 *  Returnerer null hvis ingen rader. Label-kolonnen får "Sum". */
export function computeSummaryRow(columns: ReportColumn[], rows: ReportRow[]): ReportRow | null {
  if (rows.length === 0) return null;
  const sumOf = (key: string) =>
    rows.reduce((s, r) => s + (typeof r.cells[key] === "number" ? (r.cells[key] as number) : 0), 0);
  const cells: Record<string, number | string> = {};
  for (const c of columns) {
    if (!c.summary || c.key === "label") continue;
    if (c.summary.kind === "sum") cells[c.key] = sumOf(c.key);
    else if (c.summary.kind === "ratio") {
      const den = sumOf(c.summary.b);
      cells[c.key] = den ? (sumOf(c.summary.a) / den) * 100 : 0;
    } else {
      const den = sumOf(c.summary.b);
      cells[c.key] = den ? ((sumOf(c.summary.a) - den) / den) * 100 : 0;
    }
  }
  return { id: "__summary__", label: "Sum", cells, canDrill: false };
}
